export const HOW_IT_WORKS_MODAL = "how-it-works-modal";
export const SHARE_LINK_MODAL = "share-link-modal";
export const SIZE_CHART_MODAL = "size-chart-modal";
export const PRODUCT_DETAILS_MODAL = "product-details-modal";
export const ADD_LOGO_MODAL = "add-logo-modal";
export const SAVE_BOX_ALERT = "save-box-alert";
export const TRANSFER_POINTS_MODAL = "transfer-points";
export const MANAGE_POINTS_MODAL = "manage-points";
export const ADD_ONDEMAND_MODAL = "add-ondemand";
export const KIT_STATUS_MODAL = "kit-status";
